"use client"

/**
 * Optimizations to enable back/forward cache (bfcache)
 * This helps improve navigation performance when users use browser back/forward buttons
 */

export function setupBfCacheOptimization() {
  if (typeof window === "undefined") return

  // Handle page show event to restore page from bfcache
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      // Page was restored from bfcache — revalidate stale data if needed
    }
  })

  // Intercept and suppress any beforeunload/unload registrations from third-party
  // code to keep the page bfcache-eligible. Those events block bfcache entirely.
  const originalAddEventListener = window.addEventListener.bind(window)
  window.addEventListener = function <K extends keyof WindowEventMap>(
    type: K | string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    if (type === "beforeunload" || type === "unload") {
      // Silently drop — use pagehide for cleanup instead
      return
    }
    return originalAddEventListener(
      type as keyof WindowEventMap,
      listener as EventListener,
      options
    )
  } as typeof window.addEventListener

  // Use pagehide for any teardown work (safe for bfcache)
  originalAddEventListener("pagehide", (_event) => {
    // Perform cleanup here if needed (close connections, flush queues, etc.)
  })
}
